import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";
import { AppService } from "../../services/app.service";
import { Router } from "../../../../node_modules/@angular/router";
import { SupportService } from "../../services/support-service";
import { ToastrService } from "ngx-toastr";
import { SCHEDMED_ADMIN_ROUTE_SEGMENT } from "../../admin-route-segment";

@Component({
  selector: "app-signin",
  templateUrl: "./signin.component.html",
})
export class SigninComponent implements OnInit {
  private readonly invalidCredentialsMessage = "Incorrect username or password";

  modalRef: BsModalRef;
  loginForm: FormGroup;
  loginSubmitted = false;
  selectedlang: any = [];
  buttonloader = false;
  loginerrormsg: string;
  validationDiv: boolean;
  successmsg = "";
  passwordview: any = "password";
  newpasswordview: any = "password";
  accessToken: any;
  loginUserId: any;
  loginUserType: any;
  loginUserTypeName: any;

  subscriptionDone = "false";
  givenEmail: any;
  config = {
    ignoreBackdropClick: true,
  };
  @ViewChild("confirmregistrationpopup") registerpopup: TemplateRef<any>;
  @ViewChild("unverifiedaccount") unverifiedaccount: TemplateRef<any>;
  @ViewChild("requiredpopup") requiredpopup: TemplateRef<any>;
  @ViewChild("holdaccount") holdaccount: TemplateRef<any>;
  constructor(
    private modalService: BsModalService,
    private toastr: ToastrService,
    private loginBuilder: FormBuilder,
    private appservice: AppService,
    private router: Router,
    private support: SupportService
  ) {
    this.loginForm = this.loginBuilder.group({
      email: [
        "",
        [Validators.required, Validators.pattern(environment.emailPattern)],
      ],
      password: ["", Validators.required],
      rememberme: [false],
    });
    this.loginerrormsg = null;
    this.validationDiv = false;
  }

  ngOnInit() {
    
    this.appservice.signout();
    this.support.patientname.next("");
    this.appservice.getlang().subscribe((res) => {
      if (res && res["signin"]) {
        this.selectedlang = res["signin"];
      }
    });
    const verifyLink: string[] = this.router.url
      .toString()
      .trim()
      .split("?vurl=");
    if (verifyLink.length > 1) {
      const data = {
        vurl: verifyLink[1],
      };
      this.appservice.verifyLink(data).subscribe((res) => {
        this.validationDiv = false;
        this.loginerrormsg = "";
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (localStorage.getItem("accesstoken") != null) {
            if (
              res["entity"] &&
              res["entity"]["testCenter"] &&
              res["entity"]["testCenter"]["tcCode"]
            ) {
              localStorage.setItem(
                "testCode",
                res["entity"]["testCenter"]["tcCode"]
              );
              if (res["patient_fee_amount"] || res["subscription_amount"]) {
                this.toastr.error(
                  "Your account was locked due to payment issue"
                );
              } else {
                this.router.navigate([
                  localStorage.getItem("testCode").toString().trim(),
                  "home-calendar",
                ]);
              }
              return;
            }
          } else {
            this.successmsg = this.selectedlang.verifyMessage;
            this.loginForm.controls["email"].setValue(res["entity"]["email"]);
            setTimeout(() => {
              this.successmsg = "";
            }, 3000);
            this.router.navigate(["/login"]);
            return;
          }
        } else if (res && res["status"] && res["status"]["status"] === 302) {
          this.validationDiv = true;
          this.loginerrormsg = this.selectedlang.expiredLink;
          setTimeout(() => {
            this.validationDiv = false;
          }, 5000);
        }
      });
    }
    if (localStorage.getItem("email") && localStorage.getItem("password")) {
      this.loginForm.controls["email"].setValue(localStorage.getItem("email"));
      this.loginForm.controls["password"].setValue(
        localStorage.getItem("password")
      );
      this.loginForm.controls["rememberme"].setValue(true);
    } else if (localStorage.getItem("email")) {
      this.loginForm.controls["email"].setValue(localStorage.getItem("email"));
    }
  }

  autoLogin(data) {
    if (data) {
      this.appservice.loginService(data).subscribe(
        (res) => {
          if (this.hasLoginErrorCode(res, 4)) {
            this.openModal(this.registerpopup);
            return;
          }
          sessionStorage.setItem("accountStatus", res["Account_status"]["id"]);
          if (
            res &&
            res["Account_status"] &&
            (res["Account_status"]["id"] === 1 ||
              res["Account_status"]["id"] === "1")
          ) {
            if (res["User_type"] && res["User_type"]["userTypeId"]) {
              this.loginUserType = res["User_type"]["userTypeId"];
              this.loginUserTypeName = res["User_type"]["userTypeName"];
              sessionStorage.setItem("usertype", this.loginUserType);
              sessionStorage.setItem("usertypename", this.loginUserTypeName);
            }
            if (res["User_id"]) {
              this.loginUserId = res["User_id"];
              sessionStorage.setItem("userid", this.loginUserId);
            }

            if (res["access_token"]) {
              this.accessToken = res["access_token"];
              localStorage.setItem("accesstoken", this.accessToken);
            }
            this.openModal(this.unverifiedaccount);
          }
          if (res && (res["error_code"] === 4 || res["error_code"] === "4")) {
            this.openModal(this.registerpopup);
          }
          if (res && (res["error_code"] === 3 || res["error_code"] === "3")) {
            this.openModal(this.unverifiedaccount);
          }
          if (res && (res["error_code"] === 5 || res["error_code"] === "5")) {
            this.openModal(this.holdaccount);
          }
        },
        (err) => {
          if (this.hasLoginErrorCode(err, 4)) {
            this.openModal(this.registerpopup);
          } else if (this.hasLoginErrorCode(err, 3)) {
            this.openModal(this.unverifiedaccount);
          }
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  openModal(template: TemplateRef<any>) {
    this.givenEmail = this.loginForm.get("email").value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  openModal1(template: TemplateRef<any>) {
    this.givenEmail = this.loginForm.get("email").value;
    this.modalRef = this.modalService.show(template, {backdrop : 'static', keyboard : false, class: 'popup-center-new modal-lg' });
  }

  handleRememberMe(loginForm) {
    if (loginForm.rememberme) {
      localStorage.setItem("email", loginForm.email);
      localStorage.setItem("password", loginForm.password);
    } else {
      localStorage.removeItem("email");
      localStorage.removeItem("password");
    }
  }

  getLoginFailureMessage(errorResponse) {
    const errorBody =
      errorResponse && errorResponse["error"] && typeof errorResponse["error"] === "object"
        ? errorResponse["error"]
        : errorResponse;
    if (!errorBody) {
      return this.selectedlang.validpass;
    }
    if (
      errorBody["error"] === "invalid_credentials" ||
      errorBody["error"] === "invalid_grant"
    ) {
      return errorBody["error_description"] || this.invalidCredentialsMessage;
    }
    return errorBody["error_description"] || this.selectedlang.validpass;
  }

  hasLoginErrorCode(response, code) {
    const errorBody =
      response && response["error"] && typeof response["error"] === "object"
        ? response["error"]
        : response;
    return (
      errorBody &&
      (errorBody["error_code"] === code || errorBody["error_code"] === String(code))
    );
  }

  showLoginFailure(message) {
    this.validationDiv = true;
    this.loginerrormsg = message;
    this.buttonloader = false;
    setTimeout(() => {
      this.validationDiv = false;
    }, 5000);
  }

  LoginRegister(data) {
    this.loginSubmitted = true;
    if (data.valid) {
      this.validationDiv = false;
      this.buttonloader = true;
      this.loginSubmitted = false;
      if (data.value && data.value.password) {
        if (data.value.password.match(environment.passwordPattern)) {
          this.appservice.loginService(data.value).subscribe(
            (res) => {
              if (this.hasLoginErrorCode(res, 4)) {
                this.openModal(this.registerpopup);
                this.buttonloader = false;
                return;
              }
              if (res && res["error"]) {
                this.showLoginFailure(this.getLoginFailureMessage(res));
                return;
              }
              this.handleRememberMe(data.value);
              this.validationDiv = false;
              if (
                res &&
                res["Account_status"] &&
                (res["Account_status"]["id"] === 1 ||
                  res["Account_status"]["id"] === "1")
              ) {
                this.openModal(this.unverifiedaccount);
              }
              if (
                res &&
                res["Account_status"] &&
                (res["Account_status"]["id"] === 2 ||
                  res["Account_status"]["id"] === "2")
              ) {
                if (res["User_type"] && res["User_type"]["userTypeId"]) {
                  this.loginUserType = res["User_type"]["userTypeId"];
                  this.loginUserTypeName = res["User_type"]["userTypeName"];
                  sessionStorage.setItem("usertype", this.loginUserType);
                  sessionStorage.setItem(
                    "usertypename",
                    this.loginUserTypeName
                  );
                }
                if (res["User_id"]) {
                  this.loginUserId = res["User_id"];
                  sessionStorage.setItem("userid", this.loginUserId);
                }

                if (res["access_token"]) {
                  this.accessToken = res["access_token"];
                  localStorage.setItem("accesstoken", this.accessToken);
                  localStorage.setItem("country_code", res["country_code"]);
                }

                if (
                  res["Unique_Code"] &&
                  res["User_type"]["userTypeId"] === 2
                ) {
                  if (res["patient_fee_amount"] || res["subscription_amount"]) {
                    this.toastr.error(
                      "Your account was locked due to payment issue"
                    );
                  } else {
                    localStorage.setItem("testCode", res["Unique_Code"]);
                    localStorage.setItem("testCenterId", res["tc_id"]);
                    if (localStorage.getItem("testCode") !== null) {
                      if (res["profile_updated"] === true) {
                        this.getPlanList(res["User_type"]["userTypeId"]);
                      } else {
                        localStorage.setItem("subscriptionflag", "false");
                        this.router.navigate([
                          localStorage.getItem("testCode").toString().trim(),
                          "basicinfo",
                        ]);
                      }
                    }
                  }
                } else if (
                  res["User_type"] &&
                  (res["User_type"]["userTypeId"] === 1 ||
                    res["User_type"]["userTypeId"] === "1")
                ) {
                  const uniqueCode = res["Unique_Code"]
                    ? String(res["Unique_Code"]).trim()
                    : "";
                  if (uniqueCode) {
                    localStorage.setItem("testCode", uniqueCode);
                    if (res["tc_id"] !== null && res["tc_id"] !== "") {
                      localStorage.setItem("testCenterId", String(res["tc_id"]));
                    }
                    this.router.navigate([
                      uniqueCode,
                      SCHEDMED_ADMIN_ROUTE_SEGMENT,
                      "dashboard",
                    ]);
                  } else {
                    localStorage.removeItem("testCode");
                    localStorage.removeItem("testCenterId");
                    this.router.navigateByUrl(
                      "/" + SCHEDMED_ADMIN_ROUTE_SEGMENT + "/dashboard"
                    );
                  }
                } else if (
                  res["Unique_Code"] &&
                  res["User_type"]["userTypeId"] === 3
                ) {
                  if (res["patient_fee_amount"] || res["subscription_amount"]) {
                    this.toastr.error(
                      "Your account was locked due to payment issue"
                    );
                  } else {
                    localStorage.setItem("testCode", res["Unique_Code"]);
                    localStorage.setItem("testCenterId", res["tc_id"]);
                    localStorage.setItem("frontdesk", res["fd_id"]);
                    if (localStorage.getItem("testCode") !== null) {
                      if (res["profile_updated"] === true) {
                        this.getPlanList(res["User_type"]["userTypeId"]);
                      } else {
                        localStorage.setItem("subscriptionflag", "false");
                        this.router.navigate([
                          localStorage.getItem("testCode").toString().trim(),
                          "basicinfo",
                        ]);
                      }
                    }
                  }
                }
              }
              if (
                res &&
                (res["error_code"] === 4 || res["error_code"] === "4")
              ) {
                this.openModal(this.registerpopup);
              }
              if (
                res &&
                (res["error_code"] === 3 || res["error_code"] === "3")
              ) {
                this.openModal(this.unverifiedaccount);
              }
              if (
                res &&
                (res["error_code"] === 5 || res["error_code"] === "5")
              ) {
                this.toastr.error(res["error_description"]);
              }
              this.buttonloader = false;
            },
            (err) => {
              this.appservice.sessionOut(err);
              if (this.hasLoginErrorCode(err, 4)) {
                this.buttonloader = false;
                this.openModal(this.registerpopup);
              } else if (this.hasLoginErrorCode(err, 3)) {
                this.buttonloader = false;
                this.openModal(this.unverifiedaccount);
              } else {
                this.showLoginFailure(this.getLoginFailureMessage(err));
              }
            }
          );
        } else {
          this.openModal(this.requiredpopup);
          this.buttonloader = false;
        }
      }
    } else if (
      !this.requiredValidation(this.loginForm.controls["email"].value) ||
      (!this.requiredValidation(this.loginForm.controls["password"].value) &&
        this.loginSubmitted === true)
    ) {
      this.validationDiv = true;
      this.loginerrormsg = this.selectedlang.missingfields;
      setTimeout(() => {
        this.validationDiv = false;
      }, 5000);
    } else if (
      this.loginSubmitted &&
      !this.emailPatternValidation(this.loginForm.controls["email"].value)
    ) {
      this.validationDiv = true;
      this.loginerrormsg = this.selectedlang.validEmail;
      setTimeout(() => {
        this.validationDiv = false;
      }, 5000);
    }
  }
  getPlanList(usertype) {
    this.appservice
      .getPlanList(localStorage.getItem("testCenterId").toString())
      .subscribe((plan) => {
        if (plan["entity"]) {
          this.subscriptionDone = "true";
          this.router.navigate([
            localStorage.getItem("testCode").toString().trim(),
            "home-calendar",
          ]);
        } else {
          this.subscriptionDone = "false";
          if(usertype === 3) {
            this.toastr.success('Subscription not activated by imaging center.');
            return;
          } else {
            this.router.navigate([
              localStorage.getItem("testCode").toString().trim(),
              "plan-subscription",
            ]);
          }
        }
        localStorage.setItem("subscriptionflag", this.subscriptionDone);
      });
  }

  forgotMethod() {
    localStorage.setItem("email", this.loginForm.controls["email"].value);
    this.router.navigate(["/forgotpassword"]);
  }

  navigateURL(url) {
    if (url) {
      this.appservice.navigation(url);
    }
  }

  emailPatternValidation(data): boolean {
    if (data && data != null) {
      const email = this.loginForm.controls["email"].value;
      if (email.match(environment.emailPattern)) {
        return true;
      }
      return false;
    }
    return false;
  }

  requiredValidation(data): boolean {
    if (data && data != null) {
      return true;
    }
    return false;
  }

  registeruser() {
    const data = {
      email: this.loginForm.get("email").value,
      password: this.loginForm.get("password").value,
    };
    this.appservice.userregister(data).subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          (res["status"]["status"] === 200 || res["status"]["status"] === "200")
        ) {
          this.modalRef.hide();
          if (
            res["entity"] &&
            res["entity"]["testCenter"] &&
            res["entity"]["testCenter"]["tcCode"]
          ) {
            localStorage.setItem(
              "testCode",
              res["entity"]["testCenter"]["tcCode"]
            );
          }
          this.autoLogin(data);
        } else if (
          res &&
          res["status"] &&
          (res["status"]["status"] === 230 || res["status"]["status"] === "230")
        ) {
          this.modalRef.hide();
          this.openModal(this.requiredpopup);
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  closeconfirmmodel() {
    this.loginForm.reset();
    this.closemodel();
  }

  closeTrigger(value) {
    document.getElementById(value).click();
  }

  closemodel() {
    this.modalRef.hide();
  }
  hidepassword(type) {
    if (type === "p") {
      this.passwordview = this.selectedlang.passwordviewtxt;
    }
  }

  viewpassword(type) {
    if (type === "p") {
      this.passwordview = this.selectedlang.passwordviewtxt2;
    }
  }
}
